import { useRecoilState } from "recoil";
import { mostrarCapag } from "../atom";

const useMostrarCapagState = () => {
    return useRecoilState(mostrarCapag);
};

export default useMostrarCapagState;